module.exports = __webpack_public_path__ + "img/1569850005.957443fb.jpg";